// src/admin/pages/AdminAnalytics.js
import React, { useEffect, useState, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import {
  FaShoppingCart,
  FaUsers,
  FaDollarSign,
  FaChartLine,
  FaBox,
} from "react-icons/fa";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { getAdminAnalytics } from "../../services/adminAnalytics.api";

// Chart.js imports
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

import { Line, Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Tooltip,
  Legend
);



function AdminAnalytics() {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const { lang } = useContext(AdminLanguageContext);

  const [weekOffset, setWeekOffset] = useState(0);
  const [monthOffset, setMonthOffset] = useState(0);

 
  
  const [metric, setMetric] = useState("sales"); 
// sales | orders | customers | sessions

const [dayOffset, setDayOffset] = useState(0);
const [yearOffset, setYearOffset] = useState(0);

const [productPublicId, setProductPublicId] = useState("");
const [productResult, setProductResult] = useState(null);

const [showExport, setShowExport] = useState(false);
const [exportType, setExportType] = useState("today");
const [exportFrom, setExportFrom] = useState("");
const [exportTo, setExportTo] = useState("");
const [exportData, setExportData] = useState(null);


const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
const isAdmin = adminUser.role === "admin";

const canAccess = isAdmin || perms.can_view_analytics;



const getDailyTitle = () => {
  const d = new Date();
  d.setDate(d.getDate() - dayOffset);

  if (dayOffset === 0) {
    return lang === "AR" ? "اليوم" : "Today";
  }

  if (dayOffset === 1) {
    return lang === "AR" ? "أمس" : "Yesterday";
  }

  const weekday = d.toLocaleDateString(
    lang === "AR" ? "ar" : "en",
    { weekday: "long" }
  );

  const date = d.toLocaleDateString(
    lang === "AR" ? "ar" : "en",
    { day: "numeric", month: "short" }
  );

  return `${weekday} (${date})`;
};

const handleExport = async () => {
  const today = new Date().toISOString().slice(0, 10);

  let from = today;
  let to = today;

  if (exportType === "week") {
    const d = new Date();
    d.setDate(d.getDate() - d.getDay());
    from = d.toISOString().slice(0, 10);
  }

  if (exportType === "month") {
    from = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      .toISOString().slice(0, 10);
  }

  if (exportType === "year") {
    from = `${new Date().getFullYear()}-01-01`;
  }

  if (exportType === "range") {
    from = exportFrom;
    to = exportTo;
  }

  const res = await getAdminAnalytics({
  exportFrom: from,
  exportTo: to,
});

if (!res.exportSummary) {
  console.error("Export summary missing", res);
  return;
}

setExportData({
  sales: res.exportSummary.sales || 0,
  orders: res.exportSummary.orders || 0,
  customers: res.exportSummary.customers || 0,
  sessions: res.exportSummary.sessions || 0,
  from,
  to,
});

setShowExport(false);

};


  const TEXT = {
  EN: {
    loading: "Loading analytics...",
    title: "Analytics Dashboard",

    totalSales: "Total Sales",
    totalDiscounts: "Total Discounts",
    totalOrders: "Total Orders",
    customers: "Customers",
    products: "Products",

    sales: "Sales",
    orders: "Orders",
    sessions: "Sessions",

    total: "Total",
    prev: "Prev",
    next: "Next",

    topProducts: "Top Selling Products",
    unitsSold: "Units Sold",

    productLookup: "Product Sales Lookup",
    enterPublicId: "Enter product public_id",
    check: "Check",
    notFound: "Product not found",

    dayComparison: "Day Comparison",
    today: "Today",
    yesterday: "Yesterday",

    weekComparison: "Week Comparison",
    thisWeek: "This week",
    lastWeek: "Last week",

    monthComparison: "Month Comparison",
    thisMonth: "This month",
    lastMonth: "Last month",

    yearComparison: "Year Comparison",
    thisYear: "This year",
    lastYear: "Last year",

    export: "Export / Print",
    exportTitle: "Export Analytics",
    generate: "Generate",
    cancel: "Cancel",

    reportTitle: "Analytics Report",
    from: "From",
    to: "To",

    metric: "Metric",
    print: "Print",

    exportToday: "Today",
exportWeek: "This Week",
exportMonth: "This Month",
exportYear: "This Year",
exportRange: "Custom Range",

    days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  },

  AR: {
    loading: "جاري تحميل التحليلات...",
    title: "لوحة التحليلات",

    totalSales: "إجمالي المبيعات",
    totalDiscounts: "إجمالي الخصومات",
    totalOrders: "إجمالي الطلبات",
    customers: "العملاء",
    products: "المنتجات",

    sales: "المبيعات",
    orders: "الطلبات",
    sessions: "الجلسات",

    total: "الإجمالي",
    prev: "السابق",
    next: "التالي",

    topProducts: "المنتجات الأكثر مبيعًا",
    unitsSold: "الوحدات المباعة",

    productLookup: "بحث مبيعات المنتج",
    enterPublicId: "أدخل public_id للمنتج",
    check: "تحقق",
    notFound: "المنتج غير موجود",

    dayComparison: "مقارنة اليوم",
    today: "اليوم",
    yesterday: "أمس",

    weekComparison: "مقارنة الأسبوع",
    thisWeek: "هذا الأسبوع",
    lastWeek: "الأسبوع الماضي",

    monthComparison: "مقارنة الشهر",
    thisMonth: "هذا الشهر",
    lastMonth: "الشهر الماضي",

    yearComparison: "مقارنة السنة",
    thisYear: "هذه السنة",
    lastYear: "السنة الماضية",

    export: "تصدير / طباعة",
    exportTitle: "تصدير التحليلات",
    generate: "إنشاء",
    cancel: "إلغاء",

    reportTitle: "تقرير التحليلات",
    from: "من",
    to: "إلى",

    metric: "المؤشر",
    print: "طباعة",

    exportToday: "اليوم",
exportWeek: "هذا الأسبوع",
exportMonth: "هذا الشهر",
exportYear: "هذه السنة",
exportRange: "نطاق مخصص",


    days: ["الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت", "الأحد"],
  },
}[lang];

  const load = async (w = weekOffset, m = monthOffset) => {
    setLoading(true);
    try {
      const res = await getAdminAnalytics({
  weekOffset: w,
  monthOffset: m,
  yearOffset,
  dayOffset,
  productPublicId: productPublicId || undefined,
});
      setData(res);
      setProductResult(res.productSales || null);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  load(weekOffset, monthOffset);
  // eslint-disable-next-line react-hooks/exhaustive-deps
                  }, [weekOffset, monthOffset, yearOffset, dayOffset]);

  const resolveValues = (block) => {
  if (!block) return [];
  return block[metric] || [];
};



const metricLabel = {
  sales: TEXT.sales,
  orders: TEXT.orders,
  customers: TEXT.customers,
  sessions: TEXT.sessions,
}[metric];


const calculateTotal = (values = []) => {
  return values.reduce((sum, v) => sum + (Number(v) || 0), 0);
};

const formatTotal = (total) => {
  if (metric === "sales") {
    return `$${total.toFixed(2)}`;
  }
  return total;
};



  if (loading || !data) {
    return (
      <div className={`flex bg-gray-100 min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
        <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
        <div className="flex-1 lg:ml-64 transition-all duration-300">
          <AdminHeader setIsOpen={setIsOpen} />
          <div className="p-10 text-center text-xl text-gray-500 animate-pulse">
            {TEXT.loading}
          </div>
        </div>
      </div>
    );
  }

const dayComparison = data.dayComparison || {
  today: 0,
  yesterday: 0,
  percent: 0,
};

const monthComparison = data.monthComparison || {
  thisMonth: 0,
  lastMonth: 0,
  percent: 0,
};

const yearComparison = data.yearComparison || {
  thisYear: 0,
  lastYear: 0,
  percent: 0,
};


  // ✅ SAFE TOTALS (data is guaranteed here)
const dailyTotal = formatTotal(
  metric === "orders"
    ? calculateTotal(data.daily?.orders || [])
    : calculateTotal(resolveValues(data.daily))
);

const weeklyTotal = formatTotal(
  metric === "orders"
    ? calculateTotal(data.weekly?.orders || [])
    : calculateTotal(resolveValues(data.weekly))
);

const monthlyTotal = formatTotal(
  metric === "orders"
    ? calculateTotal(data.monthly?.orders || [])
    : calculateTotal(resolveValues(data.monthly))
);


const yearlyTotal = formatTotal(
  calculateTotal(resolveValues(data.yearly))
);

const yearlyLabels =
  data.yearly?.labels?.map((m) =>
    new Date(2000, Number(m) - 1, 1).toLocaleString(
      lang === "AR" ? "ar" : "en",
      { month: "short" }
    )
  ) || [];

   
   const dailyLabels = data.daily?.labels || [];
const dailySales = data.daily?.sales || [];

const comparison = data.comparison || {
  thisWeek: 0,
  lastWeek: 0,
  percent: 0,
};

  // ✅ SAFE labels (data is guaranteed to exist here)
const weeklyLabel = (() => {
  if (!data.weekly?.startDate) return "";
  const d = new Date(data.weekly.startDate);
  const month = d.toLocaleString(lang === "AR" ? "ar" : "en", { month: "long" });
  const weekOfMonth = Math.ceil(d.getDate() / 7);
  return lang === "AR"
    ? `الأسبوع ${weekOfMonth} من ${month}`
    : `Week ${weekOfMonth} of ${month}`;
})();

const monthlyLabel = (() => {
  if (!data.monthly?.monthStart) return "";
  const d = new Date(data.monthly.monthStart);
  return d.toLocaleString(lang === "AR" ? "ar" : "en", {
    month: "long",
    year: "numeric",
  });
})();


  const weeklySales = data.weekly?.sales || [0,0,0,0,0,0,0];
  const monthlyLabels = data.monthly?.labels || [];
  const monthlySales = data.monthly?.sales || [];

  const topLabels = (data.topProducts || []).map((p) =>
    lang === "AR" ? p.name_ar : p.name_en
  );

  const topValues = (data.topProducts || []).map((p) => p.sales);

  return (
    <div className={`flex bg-gray-100 min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className="flex-1 lg:ml-64 transition-all duration-300">
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-6">
    
    {/* 🚫 Mobile block message */}
<div className="block md:hidden">
  <div className="min-h-[60vh] flex items-center justify-center px-6">
    <div className="bg-white border rounded-2xl p-6 text-center shadow max-w-sm">
      <h2 className="text-lg font-bold text-gray-800 mb-2">
        {lang === "AR"
          ? "هذه الميزة متاحة فقط على أجهزة الكمبيوتر"
          : "This feature is available only on desktop"}
      </h2>
      <p className="text-gray-500 text-sm">
        {lang === "AR"
          ? "يرجى استخدام جهاز لوحي أو كمبيوتر للوصول إلى هذه الصفحة"
          : "Please use a tablet or desktop device to access this page"}
      </p>
    </div>
  </div>
</div>

<div className="hidden md:block">

  {!canAccess ? (
    <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
      <p className="text-red-700 font-semibold">
        {lang === "AR"
          ? "غير مصرح لك بعرض نشاط المستخدمين"
          : "You are not allowed to view user activity"}
      </p>
    </div>
  ) : (
    <>

          <div className="flex justify-between items-center mb-8">
  <h1 className="text-3xl font-bold text-cyan-700">
    {TEXT.title}
  </h1>

  <button
    onClick={() => setShowExport(true)}
    className="px-5 py-2 rounded-lg bg-cyan-600 text-white font-semibold hover:bg-cyan-700"
  >
    {TEXT.export}
  </button>
</div>


          {/* STATS CARDS */}
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4 sm:gap-6">

           <div className="bg-white p-5 sm:p-6 rounded-2xl shadow-xl flex items-center gap-3 sm:gap-4 border border-gray-200">

              <FaDollarSign className="text-4xl text-green-500" />
              <div>
                <p className="text-gray-600">{TEXT.totalSales}</p>
                <h2 className="text-2xl font-bold">${Number(data.totalSales || 0).toFixed(2)}</h2>
              </div>
            </div>
              
              <div className="bg-white p-5 sm:p-6 rounded-2xl shadow-xl flex items-center gap-3 sm:gap-4 border border-gray-200">
  <FaDollarSign className="text-4xl text-red-500" />
  <div>
    <p className="text-gray-600">{TEXT.totalDiscounts}</p>
    <h2 className="text-2xl font-bold">
      ${Number(data.totalDiscounts || 0).toFixed(2)}
    </h2>
  </div>
</div>

            <div className="bg-white p-5 sm:p-6 rounded-2xl shadow-xl flex items-center gap-3 sm:gap-4 border border-gray-200">

              <FaShoppingCart className="text-4xl text-blue-500" />
              <div>
                <p className="text-gray-600">{TEXT.totalOrders}</p>
                <h2 className="text-2xl font-bold">{data.totalOrders}</h2>
              </div>
            </div>

           <div className="bg-white p-5 sm:p-6 rounded-2xl shadow-xl flex items-center gap-3 sm:gap-4 border border-gray-200">

              <FaUsers className="text-4xl text-purple-500" />
              <div>
                <p className="text-gray-600">{TEXT.customers}</p>
                <h2 className="text-2xl font-bold">{data.totalCustomers}</h2>
              </div>
            </div>

           <div className="bg-white p-5 sm:p-6 rounded-2xl shadow-xl flex items-center gap-3 sm:gap-4 border border-gray-200">

              <FaBox className="text-4xl text-yellow-500" />
              <div>
                <p className="text-gray-600">{TEXT.products}</p>
                <h2 className="text-2xl font-bold">{data.totalProducts}</h2>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap gap-3 justify-center">
  {[
    { key: "sales", label: TEXT.sales },
  { key: "orders", label: TEXT.orders },
  { key: "customers", label: TEXT.customers },
  { key: "sessions", label: TEXT.sessions },
  ].map((b) => (
    <button
      key={b.key}
      onClick={() => setMetric(b.key)}
      className={`px-5 py-2 rounded-full border font-semibold transition
        ${
          metric === b.key
            ? "bg-cyan-600 text-white border-cyan-600"
            : "bg-white hover:bg-gray-100"
        }`}
    >
      {b.label}
    </button>
  ))}
</div>
         
         <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6">
   
   <div className="bg-white p-6 rounded-2xl shadow border">
  <div className="flex justify-between items-center mb-3">
  <div>
    <h3 className="font-bold text-cyan-700">
      {metricLabel} — {getDailyTitle()}
    </h3>
    <p className="text-sm text-gray-500">
      {TEXT.total}: <b>{dailyTotal}</b>
    </p>
  </div>

  <div className="flex gap-2">
    <button onClick={() => setDayOffset(p => p + 1)} className="btn-lite">
      {TEXT.prev}
    </button>
    <button onClick={() => setDayOffset(p => p - 1)} className="btn-lite">
      {TEXT.next}
    </button>
  </div>
</div>


  <Line
    data={{
      labels: data.daily.labels,
      datasets: [
        {
          label: metricLabel,
          data: resolveValues(data.daily),
          borderColor: "#06b6d4",
          backgroundColor: "rgba(6,182,212,.2)",
          tension: 0.3,
        },
      ],
    }}
    height={220}
  />
</div>

<div className="bg-white p-6 rounded-2xl shadow border">
 <div className="flex justify-between items-center mb-3">
  <div>
    <h3 className="font-bold text-cyan-700">
      {metricLabel} — {weeklyLabel}
    </h3>
    <p className="text-sm text-gray-500">
      {TEXT.total}: <b>{weeklyTotal}</b>
    </p>
  </div>

  <div className="flex gap-2">
    <button onClick={() => setWeekOffset(p => p + 1)} className="btn-lite">
      {TEXT.prev}
    </button>
    <button onClick={() => setWeekOffset(p => p - 1)} className="btn-lite">
      {TEXT.next}
    </button>
  </div>
</div>


  <Line
    data={{
      labels: TEXT.days,
      datasets: [
        {
          label: metricLabel,
          data: resolveValues(data.weekly),
          borderColor: "#06b6d4",
          backgroundColor: "rgba(6,182,212,.2)",
        },
      ],
    }}
    height={220}
  />
</div>


<div className="bg-white p-6 rounded-2xl shadow border">
  <div className="flex justify-between items-center mb-3">
    <div>
    <h3 className="font-bold text-cyan-700">
      {metricLabel} — {monthlyLabel}
    </h3>
    <p className="text-sm text-gray-500">
      {TEXT.total}: <b>{monthlyTotal}</b>
    </p>
  </div>
    <div className="flex gap-2">
  <button onClick={() => setMonthOffset(p => p - 1)} className="btn-lite">
    {TEXT.prev}
  </button>
  <button onClick={() => setMonthOffset(p => p + 1)} className="btn-lite">
    {TEXT.next}
  </button>
</div>
  </div>

  <Line
    data={{
      labels: data.monthly.labels,
      datasets: [
        {
          label: metricLabel,
          data: resolveValues(data.monthly),
          borderColor: "#06b6d4",
          backgroundColor: "rgba(6,182,212,.2)",
        },
      ],
    }}
    height={220}
  />
</div>

<div className="bg-white p-6 rounded-2xl shadow border">
  <div className="flex justify-between items-center mb-3">
    <div>
      <h3 className="font-bold text-cyan-700">
        {metricLabel} — {new Date().getFullYear() - yearOffset}
      </h3>
      <p className="text-sm text-gray-500">
        {TEXT.total}: <b>{yearlyTotal}</b>
      </p>
    </div>

    <div className="flex gap-2">
      <button onClick={() => setYearOffset((p) => p + 1)} className="btn-lite">
        {TEXT.prev}
      </button>
      <button onClick={() => setYearOffset((p) => p - 1)} className="btn-lite">
        {TEXT.next}
      </button>
    </div>
  </div>

  <Line
    data={{
      labels: yearlyLabels,
      datasets: [
        {
          label: metricLabel,
          data: resolveValues(data.yearly),
          borderColor: "#06b6d4",
          backgroundColor: "rgba(6,182,212,.2)",
          tension: 0.3,
        },
      ],
    }}
    height={220}
  />
</div>


</div>
          

          {/* TOP PRODUCTS (TOP 5) */}
          <div className="mt-10 bg-white p-6 rounded-2xl shadow-xl border border-gray-200">
            <h2 className="text-xl font-bold text-cyan-700 mb-4">
              {TEXT.topProducts}
            </h2>

            <div className="w-full overflow-x-auto">
              <Bar
                data={{
                  labels: topLabels,
                  datasets: [
                    {
                      label: TEXT.unitsSold,
                      data: topValues,
                      backgroundColor: [
                        "#ef4444",
                        "#f59e0b",
                        "#3b82f6",
                        "#10b981",
                        "#8b5cf6",
                      ],
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                }}
                height={window.innerWidth < 640 ? 220 : 300}
              />
            </div>
          </div>

          {/* PRODUCT SALES BY PUBLIC ID */}
<div className="mt-10 bg-white p-6 rounded-2xl shadow border">
  <h2 className="text-xl font-bold text-cyan-700 mb-4">
    {TEXT.productLookup}
  </h2>

  <div className="flex flex-col sm:flex-row gap-3 mb-4">
    <input
      type="text"
      value={productPublicId}
      onChange={(e) => setProductPublicId(e.target.value)}
      placeholder={TEXT.enterPublicId}
      className="flex-1 border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500"
    />

    <button
      onClick={() => load()}
      className="btn-lite font-semibold"
    >
      {TEXT.check}
    </button>
  </div>

  {productResult && (
    <div className="bg-gray-50 border rounded-lg p-4">
      <p className="font-semibold">
        {lang === "AR"
          ? productResult.name_ar
          : productResult.name_en}
      </p>

      <p className="text-gray-600 mt-1">
        {TEXT.unitsSold}:{" "}
        <b className="text-cyan-700">
          {productResult.units_sold}
        </b>
      </p>
    </div>
  )}

  {productPublicId && !productResult && (
    <p className="text-red-500 text-sm">
      {TEXT.notFound}
    </p>
  )}
</div>

           {/* DAY COMPARISON */}
<div className="mt-6 bg-white p-5 rounded-2xl shadow border">
  <h3 className="font-bold text-lg mb-2">{TEXT.dayComparison}</h3>
  <p>{TEXT.today}: <b>${dayComparison.today}</b></p>
  <p>{TEXT.yesterday}: <b>${dayComparison.yesterday}</b></p>
  <p className={`font-bold ${dayComparison.percent >= 0 ? "text-green-600" : "text-red-600"}`}>
    {dayComparison.percent >= 0 ? "▲" : "▼"} {dayComparison.percent}%
  </p>
</div>


          <div className="mt-8 bg-white p-5 sm:p-6 rounded-2xl shadow border text-center sm:text-left">
  <h3 className="font-bold text-lg mb-2">
    {TEXT.weekComparison}
  </h3>
 <p className="mb-1">
  {TEXT.thisWeek}: <b>${comparison.thisWeek}</b>
</p>
<p className="mb-1">
  {TEXT.lastWeek}: <b>${comparison.lastWeek}</b>
</p>
<p
  className={`font-bold ${
    comparison.percent >= 0 ? "text-green-600" : "text-red-600"
  }`}
>
  {comparison.percent >= 0 ? "▲" : "▼"} {comparison.percent}%
</p>
</div>

{/* MONTH COMPARISON */}
<div className="mt-6 bg-white p-5 rounded-2xl shadow border">
  <h3 className="font-bold text-lg mb-2">{TEXT.monthComparison}</h3>
  <p>{TEXT.thisMonth}: <b>${monthComparison.thisMonth}</b></p>
  <p>{TEXT.lastMonth}: <b>${monthComparison.lastMonth}</b></p>
  <p className={`font-bold ${monthComparison.percent >= 0 ? "text-green-600" : "text-red-600"}`}>
    {monthComparison.percent >= 0 ? "▲" : "▼"} {monthComparison.percent}%
  </p>
</div>

{/* YEAR COMPARISON */}
<div className="mt-6 bg-white p-5 rounded-2xl shadow border">
  <h3 className="font-bold text-lg mb-2">{TEXT.yearComparison}</h3>
  <p>{TEXT.thisYear}: <b>${yearComparison.thisYear}</b></p>
  <p>{TEXT.lastYear}: <b>${yearComparison.lastYear}</b></p>
  <p className={`font-bold ${yearComparison.percent >= 0 ? "text-green-600" : "text-red-600"}`}>
    {yearComparison.percent >= 0 ? "▲" : "▼"} {yearComparison.percent}%
  </p>
</div>
  </>
    )}
  </div>
        </main>

        {showExport && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl">
      <h2 className="text-xl font-bold mb-4">{TEXT.exportTitle}</h2>

      <select
        value={exportType}
        onChange={(e) => setExportType(e.target.value)}
        className="w-full border rounded-lg px-4 py-2 mb-4"
      >
        <option value="today">{TEXT.exportToday}</option>
        <option value="week">{TEXT.exportWeek}</option>
        <option value="month">{TEXT.exportMonth}</option>
        <option value="year">{TEXT.exportYear}</option>
        <option value="range">{TEXT.exportRange}</option>
      </select>

      {exportType === "range" && (
        <div className="flex gap-2 mb-4">
          <input
            type="date"
            value={exportFrom}
            onChange={(e) => setExportFrom(e.target.value)}
            className="border rounded-lg px-3 py-2 w-full"
          />
          <input
            type="date"
            value={exportTo}
            onChange={(e) => setExportTo(e.target.value)}
            className="border rounded-lg px-3 py-2 w-full"
          />
        </div>
      )}

      <div className="flex justify-end gap-2">
        <button onClick={() => setShowExport(false)} className="btn-lite">
          {TEXT.cancel}
        </button>
        <button
          onClick={handleExport}
          className="bg-cyan-600 text-white px-5 py-2 rounded-lg font-semibold"
        >
          {TEXT.generate}
        </button>
      </div>
    </div>
  </div>
)}


{exportData && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div className="relative bg-white w-full max-w-2xl rounded-xl shadow-xl p-8 print-area">
      
      {/* CLOSE BUTTON */}
      <button
        onClick={() => setExportData(null)}
        className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl font-bold"
      >
        ✕
      </button>

    <h2 className="text-2xl font-bold mb-2 text-center">
      {TEXT.reportTitle}
    </h2>

    <p className="text-center text-gray-600 mb-6">
      {TEXT.from} {exportData.from} {TEXT.to} {exportData.to}
    </p>

    <table className="w-full border-collapse border text-left">
      <thead>
        <tr className="bg-gray-100">
          <th className="border p-3">{TEXT.metric}</th>
          <th className="border p-3">{TEXT.total}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border p-3">{TEXT.sales}</td>
          <td className="border p-3">${exportData.sales.toFixed(2)}</td>
        </tr>
        <tr>
          <td className="border p-3">{TEXT.orders}</td>
          <td className="border p-3">{exportData.orders}</td>
        </tr>
        <tr>
          <td className="border p-3">{TEXT.customers}</td>
          <td className="border p-3">{exportData.customers}</td>
        </tr>
        <tr>
          <td className="border p-3">{TEXT.sessions}</td>
          <td className="border p-3">{exportData.sessions}</td>
        </tr>
      </tbody>
    </table>

    <div className="text-center mt-6">
     <button
  onClick={() => {
    const content = document.querySelector(".print-area");
    if (!content) return;

    const printWindow = window.open("", "", "width=900,height=650");

    printWindow.document.write(`
<html>
  <head>
    <title>${TEXT.reportTitle}</title>
    <style>
      body { font-family: Arial; padding: 20px; }
      table { width: 100%; border-collapse: collapse; }
      th, td { border: 1px solid #000; padding: 8px; }
      th { background: #f3f3f3; }
    </style>
  </head>
  <body>
    <h2>${TEXT.reportTitle}</h2>
    <p>${TEXT.from} ${exportData.from} ${TEXT.to} ${exportData.to}</p>

    <table>
      <tr>
        <th>${TEXT.metric}</th>
        <th>${TEXT.total}</th>
      </tr>
      <tr>
        <td>${TEXT.sales}</td>
        <td>${exportData.sales.toFixed(2)}</td>
      </tr>
      <tr>
        <td>${TEXT.orders}</td>
        <td>${exportData.orders}</td>
      </tr>
      <tr>
        <td>${TEXT.customers}</td>
        <td>${exportData.customers}</td>
      </tr>
      <tr>
        <td>${TEXT.sessions}</td>
        <td>${exportData.sessions}</td>
      </tr>
    </table>
  </body>
</html>
`);


    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  }}
  className="px-6 py-2 bg-cyan-600 text-white rounded-lg font-semibold"
>
  {TEXT.print}
</button>

    </div>
    </div>
  </div>
)}

      </div>
    </div>
  );
}

export default AdminAnalytics;